/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ImpactReport } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * ImpactReportAPIApi - axios parameter creator
 * @export
 */
export const ImpactReportAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns an impact report summarizing storage optimization value for a cluster over a time range.
         * @summary Returns an impact report: managed volume coverage and action density by outcome category.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impactReportAPIGetImpactReport: async (organizationId: string, clusterId: string, startTime?: string, endTime?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('impactReportAPIGetImpactReport', 'organizationId', organizationId)
            // verify required parameter 'clusterId' is not null or undefined
            assertParamExists('impactReportAPIGetImpactReport', 'clusterId', clusterId)
            const localVarPath = `/storage-optimization/v1alpha/organizations/{organizationId}/clusters/{clusterId}/impact-report`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"clusterId"}}`, encodeURIComponent(String(clusterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startTime !== undefined) {
                localVarQueryParameter['startTime'] = (startTime as any instanceof Date) ?
                    (startTime as any).toISOString() :
                    startTime;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImpactReportAPIApi - functional programming interface
 * @export
 */
export const ImpactReportAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImpactReportAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns an impact report summarizing storage optimization value for a cluster over a time range.
         * @summary Returns an impact report: managed volume coverage and action density by outcome category.
         * @param {string} organizationId Organization ID.
         * @param {string} clusterId Cluster ID.
         * @param {string} [startTime] Start time of the reporting period (inclusive).
         * @param {string} [endTime] End time of the reporting period (exclusive).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async impactReportAPIGetImpactReport(organizationId: string, clusterId: string, startTime?: string, endTime?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImpactReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.impactReportAPIGetImpactReport(organizationId, clusterId, startTime, endTime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ImpactReportAPIApi.impactReportAPIGetImpactReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ImpactReportAPIApi - factory interface
 * @export
 */
export const ImpactReportAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImpactReportAPIApiFp(configuration)
    return {
        /**
         * Returns an impact report summarizing storage optimization value for a cluster over a time range.
         * @summary Returns an impact report: managed volume coverage and action density by outcome category.
         * @param {ImpactReportAPIApiImpactReportAPIGetImpactReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impactReportAPIGetImpactReport(requestParameters: ImpactReportAPIApiImpactReportAPIGetImpactReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<ImpactReport> {
            return localVarFp.impactReportAPIGetImpactReport(requestParameters.organizationId, requestParameters.clusterId, requestParameters.startTime, requestParameters.endTime, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for impactReportAPIGetImpactReport operation in ImpactReportAPIApi.
 * @export
 * @interface ImpactReportAPIApiImpactReportAPIGetImpactReportRequest
 */
export interface ImpactReportAPIApiImpactReportAPIGetImpactReportRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof ImpactReportAPIApiImpactReportAPIGetImpactReport
     */
    readonly organizationId: string

    /**
     * Cluster ID.
     * @type {string}
     * @memberof ImpactReportAPIApiImpactReportAPIGetImpactReport
     */
    readonly clusterId: string

    /**
     * Start time of the reporting period (inclusive).
     * @type {string}
     * @memberof ImpactReportAPIApiImpactReportAPIGetImpactReport
     */
    readonly startTime?: string

    /**
     * End time of the reporting period (exclusive).
     * @type {string}
     * @memberof ImpactReportAPIApiImpactReportAPIGetImpactReport
     */
    readonly endTime?: string
}

/**
 * ImpactReportAPIApi - object-oriented interface
 * @export
 * @class ImpactReportAPIApi
 * @extends {BaseAPI}
 */
export class ImpactReportAPIApi extends BaseAPI {
    /**
     * Returns an impact report summarizing storage optimization value for a cluster over a time range.
     * @summary Returns an impact report: managed volume coverage and action density by outcome category.
     * @param {ImpactReportAPIApiImpactReportAPIGetImpactReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImpactReportAPIApi
     */
    public impactReportAPIGetImpactReport(requestParameters: ImpactReportAPIApiImpactReportAPIGetImpactReportRequest, options?: RawAxiosRequestConfig) {
        return ImpactReportAPIApiFp(this.configuration).impactReportAPIGetImpactReport(requestParameters.organizationId, requestParameters.clusterId, requestParameters.startTime, requestParameters.endTime, options).then((request) => request(this.axios, this.basePath));
    }
}

